import { faCoins } from '@fortawesome/free-solid-svg-icons/faCoins';
import Typography from '@mui/material/Typography';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import { DynamicAuctionFilters } from 'shared/types/api/getAuctions';
import { moneyFormat } from 'utils/functions';
import { MSRPSliderContainerMui5 } from '../components';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { isEqualRange } from '../../../../../services/filters/utils';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

const MSRP_FILTER_STEP = 1000;

const MSRPSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: 5,
  padding: '13px 0',
  '& .MuiSlider-track': {
    borderRadius: theme.shape.borderRadius,
    height: 5,
  },
  '& .MuiSlider-rail': {
    backgroundColor: theme.palette.primary.light,
    borderRadius: theme.shape.borderRadius,
    height: 5,
  },
  '& .MuiSlider-thumb': {
    height: 14,
    width: 14,
    marginTop: 0,
    marginLeft: 0,
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiSlider-mark': {
    display: 'none',
  },
  '& .MuiSlider-markLabel': {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    transform: 'none !important',
    '&[data-index="0"]': {
      left: '0!important',
    },
    '&[data-index="1"]': {
      left: 'initial!important',
      right: '0!important',
    },
  },
  '& .MuiSlider-markLabelActive': {
    color: theme.palette.text.primary,
  },
}));

export const MSRPFilter = ({
  dynamicFilters,
  setFilterValue,
  disabled = false,
}: {
  dynamicFilters: DynamicAuctionFilters;
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();
  const msrp = filters.msrp?.length ? filters.msrp : dynamicFilters.msrp;
  const [sliderValue, setSliderValue] = useState(msrp || []);

  if (!dynamicFilters.msrp?.[0]) {
    return null;
  }

  return (
    <MSRPSliderContainerMui5>
      <Typography variant='body1'>
        <Typography variant='body1' component='span' noWrap>
          <FieldLabelIconMui5 icon={faCoins} /> MSRP&nbsp;&nbsp;&nbsp;&nbsp;
        </Typography>
        {filters.msrp?.map((v) => moneyFormat(v)).join(' – ')}
      </Typography>

      <MSRPSlider
        getAriaLabel={(index) =>
          index === 0 ? 'Minimum MSRP' : 'Maximum MSRP'
        }
        name='msrp'
        step={MSRP_FILTER_STEP}
        min={dynamicFilters.msrp[0]}
        max={dynamicFilters.msrp[1]}
        marks={dynamicFilters.msrp.map((msrp) => ({
          value: msrp,
          label: moneyFormat(msrp),
        }))}
        valueLabelDisplay='off'
        value={sliderValue}
        onChange={(_, newValue: number[]) => {
          if (disabled) {
            return;
          }
          setSliderValue(newValue);
        }}
        onChangeCommitted={(_, value: number[]) => {
          if (disabled) {
            return;
          }
          if (isEqualRange(value, dynamicFilters.msrp)) {
            setFilterValue('msrp', []);
            return;
          }
          if (value[0] + MSRP_FILTER_STEP <= value[1]) {
            setFilterValue('msrp', [...value]);
          }
        }}
      />
    </MSRPSliderContainerMui5>
  );
};
